export default __webpack_public_path__ + "static/media/RIGHT-ARROW.5b9efc0c.svg";